// extracted by mini-css-extract-plugin
export default {"-large":"Jv35X_Z4YeaoZAlkNri1","container":"zYBDbjsQZ7a07BZEYptd","isCenterAligned":"f535Wx9UiUW1S7TaQxma"};